<template>
    <div class="x-ray-click-regions" tabindex="0" @keyup.enter.stop="onClick" @keydown.space.prevent="onClick"
        @click.stop="onClick">
    </div>
</template>
<script>
import { mapActions } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";

export default {
    name: "XRayClickRegions",
    mixins: [blockElementMixin, PdpProductMixin],
    props: {
        product: {
            type: Object,
            default: () => {
                return {}
            }
        },
        pageData: {
            type: Object,
        },
        flyerData: {
            type: Array,
        },
        blockRendered: {
            type: Object
        },
        pageRendered: {
            type: Object
        },
        flyerRendered: {
            type: Object
        },
        productRendered: {
            type: Object,
        },
        imageRendered: {
            type: Object,
        }
    },
    methods: {
        ...mapActions(['setXRayMode', 'setXRayData']),
        onClick() {
            this.setXRayMode(true);
            this.setXRayData({ 
                block: {
                    raw: this.blockData,
                    rendered: {
                        block: this.blockRendered,
                        product: this.productRendered,
                        image: this.imageRendered,
                    }
                }, 
                page: {
                    raw: this.pageData,
                    rendered: this.pageRendered
                },
                flyer: {
                    raw: this.flyerData,
                    rendered: this.flyerRendered
                }
             })
        }
    },

}
</script>
<style lang="scss">
.x-ray-click-regions {
    position: absolute;
    z-index: 9999999;
    width: 100%;
    height: 100%;
    cursor: pointer;  
}

</style>